<template>
  <b-container
    class="mb-5"
    fluid
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-row>
      <b-col
        cols="12"
        sm="4"
      >
        <iq-card>
          <template v-slot:body>
            <div class="d-flex d-flex align-items-center justify-content-between">
              <div>
                <h2>{{ sales_call_count }}</h2>
                <p class="fontsize-sm m-0">
                  Sales Call
                </p>
              </div>
              <div class="rounded-circle iq-card-icon  dark-icon-light iq-bg-success">
                <i class="ri-inbox-fill" /></div>
            </div>
          </template>
        </iq-card>
      </b-col>

      <b-col
        cols="12"
        sm="4"
      >
        <iq-card>
          <template v-slot:body>
            <div class="d-flex d-flex align-items-center justify-content-between">
              <div>
                <h2>{{ product_presentation_count }}</h2>
                <p class="fontsize-sm m-0">
                  Product Presentation
                </p>
              </div>
              <div class="rounded-circle iq-card-icon  dark-icon-light iq-bg-success">
                <i class="ri-inbox-fill" /></div>
            </div>
          </template>
        </iq-card>
      </b-col>

      <b-col
        cols="12"
        sm="4"
      >
        <iq-card>
          <template v-slot:body>
            <div class="d-flex d-flex align-items-center justify-content-between">
              <div>
                <h2>{{ collection_count }}</h2>
                <p class="fontsize-sm m-0">
                  Collection
                </p>
              </div>
              <div class="rounded-circle iq-card-icon  dark-icon-light iq-bg-success">
                <i class="ri-inbox-fill" /></div>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import { DSMDashboardService } from '@/services'

export default {
  name: 'DSMDashboard',

  middleware: ['auth', 'dsm'],

  metaInfo () {
    return {
      title: 'Dashboard'
    }
  },

  data () {
    return {
      sales_call_count: 0,
      product_presentation_count: 0,
      collection_count: 0
    }
  },

  mounted () {
    core.index()
    this.fetchData()
  },

  methods: {
    async fetchData () {
      await DSMDashboardService.getStatistics().then(({ data }) => {
        this.sales_call_count = data.sales_call_count
        this.product_presentation_count = data.product_presentation_count
        this.collection_count = data.collection_count
      })
    }
  }
}
</script>
